export const TRANSLATIONS = {
    EN: {
        ADVISOR: {
            JOBS: 'Jobs',
            OPEN_PROCEDURES: 'Open procedures',
            ACTIONS_REQUIRED: 'Actions required',
            YOUR_OPEN_LEADS: 'Your open leads',
            AVAILABLE_LEADS: 'Available leads',
            YOUR_ACTIONS: 'Your actions',
            VIEW_PROCEDURES: 'View procedures',
            VIEW_NEW_PROCEDURES: 'View new procedures',
            VIEW_LEADS: 'View leads',
            OPEN_LEADS: 'Open leads',
            CLOSED_LEADS: 'Closed leads',
            RECEIVE_LEADS: 'Receive leads',
            RECEIVE_LEADS_DESCRIPTION_1: 'I would like to receive leads',
            BUY_LEADS: 'Buy leads',
            BUY_LEADS_DESCRIPTION_1: 'The lead request is nationwide and won\'t be selected per region. So a lead can be originating from any province. After payment, you will receive the contact information of the potential customer in your dashboard in the "Open leads" section.',
            BUY_LEADS_DESCRIPTION_2: 'We currently have {amount} leads available. Select below the number of leads you wish to purchase.',
            NEW_PROCESS: 'New process',
            LEADS_WON: 'Leads won',
            RATING_TITLE: 'Please let us know what you thought of the quality of this lead so that we can continue to improve the quality of future leads.',
            RATING_NO_RATE: 'What was the quality of this lead?',
            RATE_VERY_BAD: 'Very bad',
            RATE_BAD: 'Bad',
            RATE_GOOD: 'Good',
            RATE_GREAT: 'Great',
            SUBMIT_RATING: 'Submit rating',
            SKIP: 'Skip',
            COMPANY_INFORMATION: 'Company information',
            CONTACT_INFORMATION: 'Contact information',
            LOST_OR_WON: 'Was this lead lost or won?',
            REGIONAL: 'Regional',
            NATIONAL: 'National',
            QUICK_ACTIONS: 'Quick actions',
            ORGANIZATIONS: 'Organizations',
            PERSONS: 'Persons',
            PROCESSES: 'Processes',
            REVENUE: 'Revenue',
            LEADS: 'Leads',
            TOTAL_IMPORTED: 'Total',
            TOTAL_IMPORTED_PERSONS: 'Total imported persons',
            VERIFIED: 'Verified',
            RUNNING_JOBS: 'Running jobs',
            COMPLETED_JOBS: 'Completed jobs',
            THIS_MONTH: 'This month',
            THIS_YEAR: 'This year',
            WON: 'Won',
            OPEN: 'Open',
            START_NEW_JOB: 'Start new job',
            START_NEW_INCORPORATION: 'Start new Incorporation',
            CURRENT_TASKS: 'Current tasks',
            DASHBOARD: 'Dashboard',
            IMPORT_ORGANIZATION: 'Import organization',
            ALL_OPTIONS: 'Other options',
            ALL_OPTIONS_DESCRIPTION: 'Can\'t find the correct options for your request?',
            COMPANY_NAME: 'Company name',
            COMPANY_REGISTRATION_NUMBER: 'Registration number',
            COMPANY_EMAIL: 'Company email',
            COMPANY_PHONE: 'Company phone',
            REGISTERED_CITY: 'Registered city',
            LEAD_TYPE_BOOKKEEPING: 'Accounting',
            LEAD_TYPE_DGA: 'Salary administration',
            LEAD_TYPE_GO_DUTCH: 'GoDutch',
        },
    },
    NL: {
        ADVISOR: {
            JOBS: 'Jobs',
            OPEN_PROCEDURES: 'Open procedures',
            ACTIONS_REQUIRED: 'Acties vereist',
            YOUR_OPEN_LEADS: 'Uw openstaande leads',
            AVAILABLE_LEADS: 'Beschikbare leads',
            YOUR_ACTIONS: 'Je acties',
            VIEW_PROCEDURES: 'Bekijk procedures',
            VIEW_NEW_PROCEDURES: 'Bekijk nieuwe procedures',
            VIEW_LEADS: 'Bekijk leads',
            OPEN_LEADS: 'Open leads',
            CLOSED_LEADS: 'Gesloten leads',
            RECEIVE_LEADS: 'Ontvang leads',
            RECEIVE_LEADS_DESCRIPTION_1: 'Ik wil graag leads ontvangen',
            BUY_LEADS: 'Koop leads',
            BUY_LEADS_DESCRIPTION_1: 'De leadaanvragen zijn landelijk en worden niet geselecteerd per regio. De lead kan dus afkomstig zijn uit iedere provincie. Na betaling ontvangt u de contactgegevens van de potentiële klant in uw dashboard onder "Open leads".',
            BUY_LEADS_DESCRIPTION_2: 'Wij hebben momenteel {amount} leads beschikbaar. Selecteer hieronder het aantal leads dat u wilt kopen.',
            NEW_PROCESS: 'Nieuw proces',
            LEADS_WON: 'Leads gewonnen',
            RATING_TITLE: 'Laat ons weten wat je vond van de kwaliteit van de lead. Op deze manier kunnen we zorgen dat de kwaliteit wordt verbeterd.',
            RATING_NO_RATE: 'Wat was de kwaliteit van de lead?',
            RATE_VERY_BAD: 'Erg slecht',
            RATE_BAD: 'Slecht',
            RATE_GOOD: 'Goed',
            RATE_GREAT: 'Super goed',
            SUBMIT_RATING: 'Beoordeling indienen',
            SKIP: 'Skip',
            COMPANY_INFORMATION: 'Bedrijfsgegevens',
            CONTACT_INFORMATION: 'Contactgegevens',
            LOST_OR_WON: 'Is deze lead gewonnen of verloren?',
            REGIONAL: 'Regionaal',
            NATIONAL: 'Nationaal',
            QUICK_ACTIONS: 'Snelle acties',
            ORGANIZATIONS: 'Organisaties',
            PERSONS: 'Personen',
            PROCESSES: 'Processen',
            REVENUE: 'Omzet',
            LEADS: 'Leads',
            TOTAL_IMPORTED: 'Totaal',
            TOTAL_IMPORTED_PERSONS: 'Total imported persons',
            VERIFIED: 'Verified',
            RUNNING_JOBS: 'Running jobs',
            COMPLETED_JOBS: 'Completed jobs',
            THIS_MONTH: 'This month',
            THIS_YEAR: 'This year',
            WON: 'Won',
            OPEN: 'Open',
            START_NEW_JOB: 'Start nieuw opdracht',
            START_NEW_INCORPORATION: 'Nieuwe oprichting',
            CURRENT_TASKS: 'Huidige taken',
            DASHBOARD: 'LegacyDashboard',
            IMPORT_ORGANIZATION: 'Importeer organisatie',
            ALL_OPTIONS: 'Andere opties',
            ALL_OPTIONS_DESCRIPTION: 'Staat uw optie er niet tussen?',
            COMPANY_NAME: 'Bedrijfsnaam',
            COMPANY_REGISTRATION_NUMBER: 'KvK nummer',
            COMPANY_EMAIL: 'e-mailadres',
            COMPANY_PHONE: 'telefoonnummer',
            REGISTERED_CITY: 'Vestigingsplaats',
            LEAD_TYPE_BOOKKEEPING: 'Boekhouding',
            LEAD_TYPE_DGA: 'Salaris administratie',
            LEAD_TYPE_GO_DUTCH: 'GoDutch',
        },
    },
};
